/* @ngInject */
const ask = (

) => {
  const self = {}

  return self
}

export default ask



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/email/services/ask.service.js